var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSubsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subs-icon",
    transform: "translate(236 -326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527",
    transform: "translate(-233 328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M25.447,5.009h3.277V2.337H20.706v8.018h2.673V6.737A12.026,12.026,0,0,1,15.4,27.726h-.04A11.959,11.959,0,0,1,5.116,22a3.043,3.043,0,0,1-.354-2.285l.715-2.98A1.347,1.347,0,0,1,6.791,15.7a3.485,3.485,0,0,0,3.224-4.825L8.96,8.357V8.339a3.341,3.341,0,1,1,6.134,0l-1.069,2.583A3.486,3.486,0,0,0,17.249,15.7a1.348,1.348,0,0,1,1.315,1.037l.712,2.972h2.747l-.861-3.593a4.008,4.008,0,0,0-3.914-3.088A.811.811,0,0,1,16.5,11.9l1.046-2.51a6.013,6.013,0,1,0-11.048,0L7.542,11.9a.811.811,0,0,1-.751,1.125,4.009,4.009,0,0,0-3.914,3.087l-.715,2.98a5.726,5.726,0,0,0,.679,4.31,14.608,14.608,0,0,0,12.52,7h.048A14.7,14.7,0,0,0,25.447,5.009Z",
    transform: "translate(-2.006 -0.999)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/subs-icon.09e56cd9.svg";
export { ForwardRef as ReactComponent };